import { __decorate, __metadata } from "tslib";
import { Component, Input, Output } from 'angular-ts-decorators';
import template from './faq-view-buttons.component.html';
var FaqViewButtonsComponent = (function () {
    function FaqViewButtonsComponent() {
    }
    FaqViewButtonsComponent.prototype.showMore = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.onShowMore) {
            this.onShowMore();
        }
    };
    FaqViewButtonsComponent.prototype.showLess = function ($event) {
        $event.preventDefault();
        if (this.onShowLess) {
            this.onShowLess();
        }
    };
    FaqViewButtonsComponent.prototype.showAllFaq = function ($event) {
        $event.preventDefault();
        if (this.onShowAllFaq) {
            this.onShowAllFaq();
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], FaqViewButtonsComponent.prototype, "showAllAvailable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], FaqViewButtonsComponent.prototype, "showLessAvailable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], FaqViewButtonsComponent.prototype, "showMoreAvailable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], FaqViewButtonsComponent.prototype, "showAllFaqAvailable", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqViewButtonsComponent.prototype, "viewAllLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqViewButtonsComponent.prototype, "viewLessLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqViewButtonsComponent.prototype, "viewMoreLabel", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], FaqViewButtonsComponent.prototype, "viewAllFaqLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], FaqViewButtonsComponent.prototype, "viewAllUrl", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], FaqViewButtonsComponent.prototype, "onShowMore", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], FaqViewButtonsComponent.prototype, "onShowLess", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Function)
    ], FaqViewButtonsComponent.prototype, "onShowAllFaq", void 0);
    FaqViewButtonsComponent = __decorate([
        Component({
            selector: 'faqViewButtons',
            template: template,
        })
    ], FaqViewButtonsComponent);
    return FaqViewButtonsComponent;
}());
export { FaqViewButtonsComponent };
